import { useDispatch, useSelector } from 'react-redux';
import './css/app.css'
import './css/main.css'
import './css/common.css'
import './css/payment.css'
import { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom"
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { LoadingModal } from './component/modal/modal';

import { Copy } from 'lucide-react';

import useWindowSize from './hook/useWindowSize'

function UrlCreate() {
    let navigate = useNavigate();
    let dispatch = useDispatch()

    const { Rwidth, Rheight } = useWindowSize();

    const [loading, setLoading] = useState(true)
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(0)
    const [maxFirstPage, setMaxFirstPage] = useState(40)

    const [listData, setListData] = useState([])
    const [reload, setReload] = useState(false)


    useEffect(() => {
        dispatch(change_Current_Location("URL상품관리"))
        dispatch(changeHeaderTitle({
            mainTitle: "URL상품관리",
            subTitle: ""
        }))
        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    useEffect(() => {
        ListData()
    }, [reload, page])

    const ListData = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/url-products", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data?.products ?? [])
                // setAmount([Number(tmp?.data?.summary?.total_amount), Number(tmp?.data?.summary?.cancel_amount)])
                setTotalPage(tmp?.data?.pagination?.total ?? 0)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    return (
        <>
            {loading ? <LoadingModal /> : ""}
            <div style={{ background: "#fff", minHeight: "100dvh" }}>
                <MobileManagement />
            </div>
        </>
    )
}

function MobileManagement() {
    const navigate = useNavigate();

    const products = [
        {
            id: 1,
            title: "디어커스 오발레 욕실화 슬리퍼",
            img: "https://picsum.photos/seed/slipper1/600/600",
            discountPct: 40,
            price: 20900,
            myPrice: 20900,
            badges: ["오늘출발", "무료배송"],
        },
        {
            id: 2,
            title: "디어커스 오발레 욕실화 슬리퍼 2세트",
            img: "https://picsum.photos/seed/slipper2/600/600",
            discountPct: 42,
            price: 39800,
            myPrice: 39800,
            badges: ["오늘출발", "무료배송"],
        },
        {
            id: 3,
            title: "디어커스 오발레 욕실화 슬리퍼 + 슬릿밤 욕실걸이",
            img: "https://picsum.photos/seed/slipper3/600/600",
            discountPct: 30,
            price: 55220,
            myPrice: 50220,
            badges: ["오늘출발", "무료배송"],
        },
        {
            id: 4,
            title: "디어커스 소파 비누받침대 비누거치대",
            img: "https://picsum.photos/seed/slipper4/600/600",
            discountPct: 27,
            price: 26900,
            myPrice: 26900,
            badges: ["무료배송"],
        },
        {
            id: 1,
            title: "디어커스 오발레 욕실화 슬리퍼",
            img: "https://picsum.photos/seed/slipper1/600/600",
            discountPct: 40,
            price: 20900,
            myPrice: 20900,
            badges: ["오늘출발", "무료배송"],
        },
        {
            id: 2,
            title: "디어커스 오발레 욕실화 슬리퍼 2세트",
            img: "https://picsum.photos/seed/slipper2/600/600",
            discountPct: 42,
            price: 39800,
            myPrice: 39800,
            badges: ["오늘출발", "무료배송"],
        }
    ];

    const fmt = (n) => n.toLocaleString("ko-KR");

    return (
        <div className="mobile-management-wrap">
            <h2 className="mobile-management-heading">A가맹점 상품목록</h2>

            <div className="mobile-management-grid">
                {products.map((p) => (
                    <article className="mobile-management-card" key={p.id}
                        onClick={() => navigate('/urlDetail')}>
                        <div className="mobile-management-thumb">
                            <img src={p.img} alt={p.title} />
                            {/* <button
                                type="button"
                                className="mobile-management-like"
                                aria-label="관심상품"
                            >
                                <svg viewBox="0 0 24 24" width="18" height="18">
                                    <path
                                        d="M12 21s-7-4.35-9.33-8.24C1.38 10.3 2.26 7.5 4.6 6.3 6.12 5.5 7.98 5.7 9.3 6.8L12 9l2.7-2.2c1.32-1.1 3.18-1.3 4.7-.5 2.34 1.2 3.22 4 1.93 6.46C19 16.65 12 21 12 21z"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.6"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </button> */}
                        </div>

                        <h3 className="mobile-management-title">{p.title}</h3>

                        <div className="mobile-management-price-row">
                            <span className="mobile-management-discount">{p.discountPct}%</span>
                            <span className="mobile-management-price">{fmt(p.price)}원</span>
                        </div>

                        <div className="mobile-management-myprice">
                            나의 할인가 <strong>{fmt(p.myPrice)}원</strong>
                        </div>

                        <div className="mobile-management-badges">
                            {p.badges.map((b, i) => (
                                <span className="mobile-management-badge" key={i}>
                                    {b}
                                </span>
                            ))}
                        </div>
                    </article>
                ))}
            </div>
        </div>
    );
}

export default UrlCreate;